import { createSelector } from "reselect";

export const platformsSelector = createSelector(
    state => state.services.platforms,
    state => state
);
